import WebFont from 'webfontloader';
const options = {
  "google": {
    "families": ["Open+Sans:400,600,700&display=swap"]
  }
};
WebFont.load(options);